import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoContent = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 45,
	height: 47,
	viewBox: "0 0 45 47",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M41.7314 44.8054C41.7314 44.7219 42.1118 44.6523 42.5873 44.6523C43.0628 44.6523 43.4431 44.7219 43.4431 44.8054C43.4431 44.8889 43.0628 44.9584 42.5873 44.9584C42.1118 44.9584 41.7314 44.8889 41.7314 44.8054Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M38.3027 44.8054C38.3027 44.7219 38.6831 44.6523 39.1586 44.6523C39.6341 44.6523 40.0144 44.7219 40.0144 44.8054C40.0144 44.8889 39.6341 44.9584 39.1586 44.9584C38.6831 44.9584 38.3027 44.8889 38.3027 44.8054Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.8652 44.8054C34.8652 44.7219 35.2456 44.6523 35.7211 44.6523C36.1966 44.6523 36.5769 44.7219 36.5769 44.8054C36.5769 44.8889 36.1966 44.9584 35.7211 44.9584C35.2456 44.9584 34.8652 44.8889 34.8652 44.8054Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.4688 44.8054C31.4688 44.7219 31.8491 44.6523 32.3246 44.6523C32.8001 44.6523 33.1804 44.7219 33.1804 44.8054C33.1804 44.8889 32.8001 44.9584 32.3246 44.9584C31.8491 44.9584 31.4688 44.8889 31.4688 44.8054Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.0068 44.8054C28.0068 44.7219 28.394 44.6523 28.8695 44.6523C29.3449 44.6523 29.7253 44.7219 29.7253 44.8054C29.7253 44.8889 29.3382 44.9584 28.8695 44.9584C28.4008 44.9584 28.0068 44.8889 28.0068 44.8054Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.5732 44.8054C24.5732 44.7219 24.9604 44.6523 25.4359 44.6523C25.9114 44.6523 26.2917 44.7219 26.2917 44.8054C26.2917 44.8889 25.9046 44.9584 25.4359 44.9584C24.9672 44.9584 24.5732 44.8889 24.5732 44.8054Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1436 44.8054C21.1436 44.7219 21.5307 44.6523 22.0062 44.6523C22.4817 44.6523 22.862 44.7219 22.862 44.8054C22.862 44.8889 22.4749 44.9584 22.0062 44.9584C21.5375 44.9584 21.1436 44.8889 21.1436 44.8054Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7148 44.8054C17.7148 44.7219 18.102 44.6523 18.5775 44.6523C19.053 44.6523 19.4333 44.7219 19.4333 44.8054C19.4333 44.8889 19.0462 44.9584 18.5775 44.9584C18.1088 44.9584 17.7148 44.8889 17.7148 44.8054Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2852 44.8054C14.2852 44.7219 14.6723 44.6523 15.141 44.6523C15.6097 44.6523 16.0037 44.7219 16.0037 44.8054C16.0037 44.8889 15.6165 44.9584 15.141 44.9584C14.6655 44.9584 14.2852 44.8889 14.2852 44.8054Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8555 44.8054C10.8555 44.7219 11.2426 44.6523 11.7113 44.6523C12.18 44.6523 12.574 44.7219 12.574 44.8054C12.574 44.8889 12.1868 44.9584 11.7113 44.9584C11.2358 44.9584 10.8555 44.8889 10.8555 44.8054Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.42578 44.8054C7.42578 44.7219 7.81295 44.6523 8.28163 44.6523C8.75031 44.6523 9.14428 44.7219 9.14428 44.8054C9.14428 44.8889 8.75711 44.9584 8.28163 44.9584C7.80616 44.9584 7.42578 44.8889 7.42578 44.8054Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.99316 44.8054C3.99316 44.7219 4.38034 44.6523 4.84902 44.6523C5.3177 44.6523 5.71166 44.7219 5.71166 44.8054C5.71166 44.8889 5.32449 44.9584 4.84902 44.9584C4.37354 44.9584 3.99316 44.8889 3.99316 44.8054Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58228 43.832C1.66379 43.832 1.73171 44.2285 1.73171 44.7085V44.8407L1.58228 44.6946C1.99662 44.6946 2.30907 44.7642 2.30907 44.8407C2.30907 44.9172 1.99662 44.9798 1.58228 44.9937H1.43964V44.7085C1.39888 44.1938 1.4668 43.832 1.58228 43.832Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 40.2852C1.66551 40.2852 1.73344 40.6817 1.73344 41.1617C1.73344 41.6416 1.66551 42.0451 1.58401 42.0451C1.5025 42.0451 1.43457 41.6486 1.43457 41.1617C1.43457 40.6747 1.46853 40.2852 1.58401 40.2852Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 36.7734C1.66551 36.7734 1.73344 37.163 1.73344 37.6499C1.73344 38.1369 1.66551 38.5264 1.58401 38.5264C1.5025 38.5264 1.43457 38.1369 1.43457 37.6499C1.43457 37.163 1.46853 36.7734 1.58401 36.7734Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 33.2578C1.66551 33.2578 1.73344 33.6474 1.73344 34.1343C1.73344 34.6212 1.66551 35.0108 1.58401 35.0108C1.5025 35.0108 1.43457 34.6212 1.43457 34.1343C1.43457 33.6474 1.46853 33.2578 1.58401 33.2578Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 29.7461C1.66551 29.7461 1.73344 30.1356 1.73344 30.6226C1.73344 31.1095 1.66551 31.4991 1.58401 31.4991C1.5025 31.4991 1.43457 31.1095 1.43457 30.6226C1.43457 30.1356 1.46853 29.7461 1.58401 29.7461Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 26.2305C1.66551 26.2305 1.73344 26.62 1.73344 27.107C1.73344 27.5939 1.66551 27.9835 1.58401 27.9835C1.5025 27.9835 1.43457 27.5939 1.43457 27.107C1.43457 26.62 1.46853 26.2305 1.58401 26.2305Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 22.7227C1.66551 22.7227 1.73344 23.1122 1.73344 23.5992C1.73344 24.0861 1.66551 24.4756 1.58401 24.4756C1.5025 24.4756 1.43457 24.0861 1.43457 23.5992C1.43457 23.1122 1.46853 22.7227 1.58401 22.7227Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 19.207C1.66551 19.207 1.73344 19.5966 1.73344 20.0835C1.73344 20.5705 1.66551 20.96 1.58401 20.96C1.5025 20.96 1.43457 20.5705 1.43457 20.0835C1.43457 19.5966 1.46853 19.207 1.58401 19.207Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 15.6875C1.66551 15.6875 1.73344 16.084 1.73344 16.5709C1.73344 17.0579 1.66551 17.4474 1.58401 17.4474C1.5025 17.4474 1.43457 17.0509 1.43457 16.5709C1.43457 16.091 1.46853 15.6875 1.58401 15.6875Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 12.1758C1.66551 12.1758 1.73344 12.5723 1.73344 13.0592C1.73344 13.5462 1.63155 13.9218 1.58401 13.9218C1.53646 13.9218 1.43457 13.5253 1.43457 13.0453C1.43457 12.5653 1.46853 12.1758 1.58401 12.1758Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 8.66016C1.66551 8.66016 1.73344 9.05667 1.73344 9.5436C1.73344 10.0305 1.63155 10.441 1.58401 10.441C1.53646 10.441 1.43457 10.0445 1.43457 9.56447C1.43457 9.08449 1.46853 8.66016 1.58401 8.66016Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.58401 5.14844C1.66551 5.14844 1.73344 5.54495 1.73344 6.03189C1.73344 6.51882 1.66551 6.90837 1.58401 6.90837C1.5025 6.90837 1.43457 6.51187 1.43457 6.03189C1.43457 5.5519 1.46853 5.14844 1.58401 5.14844Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.80696 1.89866C1.80696 1.94039 1.70508 1.98213 1.54885 2.00996L1.65753 1.89866C1.68727 2.10124 1.7009 2.30597 1.69828 2.51081C1.69828 2.99775 1.63036 3.39425 1.54885 3.39425C1.46734 3.39425 1.39941 2.99775 1.39941 2.51081C1.4002 2.30608 1.41381 2.1016 1.44017 1.89866V1.77344H1.52168C1.70508 1.81518 1.80696 1.85692 1.80696 1.89866Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.23803 1.89913C5.23803 1.98261 4.85085 2.05217 4.38217 2.05217C3.91349 2.05217 3.51953 1.98261 3.51953 1.89913C3.51953 1.81566 3.9067 1.74609 4.38217 1.74609C4.85765 1.74609 5.23803 1.81566 5.23803 1.89913Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.66776 1.89913C8.66776 1.98261 8.28738 2.05217 7.8119 2.05217C7.33643 2.05217 6.95605 1.98261 6.95605 1.89913C6.95605 1.81566 7.33643 1.74609 7.8119 1.74609C8.28738 1.74609 8.66776 1.81566 8.66776 1.89913Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0974 1.89913C12.0974 1.98261 11.7171 2.05217 11.2416 2.05217C10.7661 2.05217 10.3857 1.98261 10.3857 1.89913C10.3857 1.81566 10.7661 1.74609 11.2416 1.74609C11.7171 1.74609 12.0974 1.81566 12.0974 1.89913Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5271 1.89913C15.5271 1.98261 15.1468 2.05217 14.6713 2.05217C14.1958 2.05217 13.8154 1.98261 13.8154 1.89913C13.8154 1.81566 14.1958 1.74609 14.6713 1.74609C15.1468 1.74609 15.5271 1.81566 15.5271 1.89913Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9558 1.89913C18.9558 1.98261 18.5755 2.05217 18.1 2.05217C17.6245 2.05217 17.2441 1.98261 17.2441 1.89913C17.2441 1.81566 17.6245 1.74609 18.1 1.74609C18.5755 1.74609 18.9558 1.81566 18.9558 1.89913Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3894 1.89913C22.3894 1.98261 22.0091 2.05217 21.5336 2.05217C21.0581 2.05217 20.6777 1.98261 20.6777 1.89913C20.6777 1.81566 21.0581 1.74609 21.5336 1.74609C22.0091 1.74609 22.3894 1.81566 22.3894 1.89913Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.8191 1.89913C25.8191 1.98261 25.4387 2.05217 24.9633 2.05217C24.4878 2.05217 24.1074 1.98261 24.1074 1.89913C24.1074 1.81566 24.4878 1.74609 24.9633 1.74609C25.4387 1.74609 25.8191 1.81566 25.8191 1.89913Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.2488 1.89913C29.2488 1.98261 28.8684 2.05217 28.393 2.05217C27.9175 2.05217 27.5371 1.98261 27.5371 1.89913C27.5371 1.81566 27.9175 1.74609 28.393 1.74609C28.8684 1.74609 29.2488 1.81566 29.2488 1.89913Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.6843 1.89913C32.6843 1.98261 32.2971 2.05217 31.8217 2.05217C31.3462 2.05217 30.9658 1.98261 30.9658 1.89913C30.9658 1.81566 31.353 1.74609 31.8217 1.74609C32.2903 1.74609 32.6843 1.81566 32.6843 1.89913Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M36.114 1.89913C36.114 1.98261 35.7268 2.05217 35.2514 2.05217C34.7759 2.05217 34.3955 1.98261 34.3955 1.89913C34.3955 1.81566 34.7827 1.74609 35.2514 1.74609C35.72 1.74609 36.114 1.81566 36.114 1.89913Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.5476 1.89913C39.5476 1.98261 39.1604 2.05217 38.685 2.05217C38.2095 2.05217 37.8291 1.98261 37.8291 1.89913C37.8291 1.81566 38.2163 1.74609 38.685 1.74609C39.1536 1.74609 39.5476 1.81566 39.5476 1.89913Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M42.9773 1.89913C42.9773 1.98261 42.5901 2.05217 42.1146 2.05217C41.6392 2.05217 41.2588 1.98261 41.2588 1.89913C41.2588 1.81566 41.646 1.74609 42.1146 1.74609C42.5833 1.74609 42.9773 1.81566 42.9773 1.89913Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 4.93181C43.3638 4.93181 43.2959 4.5353 43.2959 4.04836C43.2959 3.56142 43.3638 3.17188 43.4453 3.17188C43.5268 3.17188 43.5948 3.56838 43.5948 4.04836C43.5948 4.52834 43.5268 4.93181 43.4453 4.93181Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 8.44743C43.3638 8.44743 43.2959 8.05092 43.2959 7.56399C43.2959 7.07705 43.3638 6.6875 43.4453 6.6875C43.5268 6.6875 43.5948 7.084 43.5948 7.56399C43.5948 8.04397 43.5268 8.44743 43.4453 8.44743Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 11.9592C43.3638 11.9592 43.2959 11.5627 43.2959 11.0757C43.2959 10.5888 43.3638 10.1992 43.4453 10.1992C43.5268 10.1992 43.5948 10.5957 43.5948 11.0757C43.5948 11.5557 43.5268 11.9592 43.4453 11.9592Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 15.4709C43.3638 15.4709 43.2959 15.0744 43.2959 14.5944C43.2959 14.1144 43.3638 13.7109 43.4453 13.7109C43.5268 13.7109 43.5948 14.1074 43.5948 14.5944C43.5948 15.0813 43.5268 15.4709 43.4453 15.4709Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 18.9865C43.3638 18.9865 43.2959 18.59 43.2959 18.11C43.2959 17.63 43.3638 17.2266 43.4453 17.2266C43.5268 17.2266 43.5948 17.6231 43.5948 18.11C43.5948 18.5969 43.5268 18.9865 43.4453 18.9865Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 22.4982C43.3638 22.4982 43.2959 22.1017 43.2959 21.6217C43.2959 21.1417 43.3638 20.7383 43.4453 20.7383C43.5268 20.7383 43.5948 21.1348 43.5948 21.6217C43.5948 22.1087 43.5268 22.4982 43.4453 22.4982Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 26.0099C43.3638 26.0099 43.2959 25.6134 43.2959 25.1334C43.2959 24.6535 43.3638 24.25 43.4453 24.25C43.5268 24.25 43.5948 24.6465 43.5948 25.1334C43.5948 25.6204 43.5268 26.0099 43.4453 26.0099Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 29.5225C43.3638 29.5225 43.2959 29.133 43.2959 28.646C43.2959 28.1591 43.3638 27.7695 43.4453 27.7695C43.5268 27.7695 43.5948 28.1591 43.5948 28.646C43.5948 29.133 43.5268 29.5225 43.4453 29.5225Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 33.0342C43.3638 33.0342 43.2959 32.6447 43.2959 32.1577C43.2959 31.6708 43.3638 31.2812 43.4453 31.2812C43.5268 31.2812 43.5948 31.6708 43.5948 32.1577C43.5948 32.6447 43.5268 33.0342 43.4453 33.0342Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 36.5499C43.3638 36.5499 43.2959 36.1603 43.2959 35.6734C43.2959 35.1864 43.3638 34.7969 43.4453 34.7969C43.5268 34.7969 43.5948 35.1864 43.5948 35.6734C43.5948 36.1603 43.5268 36.5499 43.4453 36.5499Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 40.0616C43.3638 40.0616 43.2959 39.672 43.2959 39.1851C43.2959 38.6982 43.3638 38.3086 43.4453 38.3086C43.5268 38.3086 43.5948 38.6982 43.5948 39.1851C43.5948 39.672 43.5268 40.0616 43.4453 40.0616Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.4453 43.5733C43.3638 43.5733 43.2959 43.1837 43.2959 42.6968C43.2959 42.2099 43.3638 41.8203 43.4453 41.8203C43.5268 41.8203 43.5948 42.2099 43.5948 42.6968C43.5948 43.1837 43.5268 43.5733 43.4453 43.5733Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.0006 42.7812H41.8965V45.9603H45.0006V42.7812Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.10416 43.2188H0V46.3978H3.10416V43.2188Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.0006 0H41.8965V3.17901H45.0006V0Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.10416 0.3125H0V3.49151H3.10416V0.3125Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 8.16667V19.8333C5.5 20.75 6.24167 21.5 7.16667 21.5H18.8333C19.75 21.5 20.5 20.75 20.5 19.8333V8.16667C20.5 7.25 19.75 6.5 18.8333 6.5H7.16667C6.24167 6.5 5.5 7.25 5.5 8.16667ZM15.5 11.5C15.5 12.8833 14.3833 14 13 14C11.6167 14 10.5 12.8833 10.5 11.5C10.5 10.1167 11.6167 9 13 9C14.3833 9 15.5 10.1167 15.5 11.5ZM8 18.1667C8 16.5 11.3333 15.5833 13 15.5833C14.6667 15.5833 18 16.5 18 18.1667V19H8V18.1667Z",
			fill: "#2196F3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.476 25.4691L17.9429 18.9195C17.8178 18.8725 17.682 18.8625 17.5514 18.8906C17.4209 18.9187 17.3011 18.9837 17.2064 19.078C17.1116 19.1723 17.0458 19.2919 17.0167 19.4225C16.9877 19.5532 16.9966 19.6895 17.0425 19.8152L23.6104 37.4209C23.6614 37.5572 23.7535 37.6742 23.874 37.7556C23.9945 37.8369 24.1372 37.8786 24.2824 37.8748C24.4276 37.8709 24.568 37.8217 24.684 37.7341C24.8 37.6465 24.8859 37.5247 24.9296 37.3859L26.8071 31.2631L33.1727 37.4908C33.3034 37.6212 33.4803 37.6943 33.6647 37.6943C33.8491 37.6943 34.026 37.6212 34.1568 37.4908L35.797 35.8464C35.927 35.7153 36 35.538 36 35.3531C36 35.1682 35.927 34.9909 35.797 34.8598L29.4525 28.66L35.476 26.7917C35.6131 26.7441 35.732 26.6548 35.8162 26.5363C35.9004 26.4178 35.9457 26.2759 35.9457 26.1304C35.9457 25.9849 35.9004 25.843 35.8162 25.7245C35.732 25.606 35.6131 25.5167 35.476 25.4691Z",
			fill: "black"
		})
	]
});
export default SvgNoContent;
